export {
  default,
  getResourcesPath,
  getPicturePath,
  acceptPictures,
  acceptDocuments,
  insertValidationPicture,
  insertValidationDocuments
} from './src/insert-resource-dialog.jsx';